// import { useEffect, useState } from "react";
import React , { useState, useRef, useEffect } from 'react'; 
import app from "../components/app";
import Widget from "../preview";
import WidgetHeader from "../preview/header"; 

const settings = {
    setFonts:function(response) {
      let setFonts = [];
      response.forEach(function(v){
        for(var k in v.elements) {
            if(v.elements[k]["properties"]["fontFamily"]) {
                if(v.elements[k]["properties"]["fontFamily"] !== "") {
                    setFonts.push(v.elements[k]["properties"]["fontFamily"]);
                }
            }
            if(v.elements[k].viewType === "grid") {
                v.elements[k].items.forEach(function(val){
                    
                    for(var key in val) {
                        //console.log(key, val[key])
                        if(key !== "viewType" && key !== "properties" && key !== "gridId" && key !== "viewId") {
                            if(val[key]["properties"]["fontFamily"]) {
                                if(val[key]["properties"]["fontFamily"] !== "") {
                                    setFonts.push(val[key]["properties"]["fontFamily"]);
                                }
                            }
                        } 
                    }
                })
            }
        }
      })
    setFonts = [...new Set(setFonts)]
    setFonts = setFonts.map(function(v){
       return v.replace(/ /g,"+");
     }).join(":wght@400;600;700&family=");
     
    

    return `https://fonts.googleapis.com/css2?family=${setFonts}:wght@400;600;700&display=swap`;
        
  },
  "cssFiles":[ 
     {
            id:"bootstrap",
            path:"https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
        },
        {
            id:"swiper-css",
            path:"https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css"
        },
        {
            id:"fontello",
            path:"https://media.mediadirhub.com/minify/css/fontello.css"
        },
         {
            id:"fontello",
            path:"https://media.mediadirhub.com/minify/css/appyslim.css"
        },
       
        
      {
          id:"header-css",
          path:"/css/headerLibrary.css"
      },
        {
          id:"pages-css",
          path:"/css/pages.css"
        }
        
    ],
    "jsFiles":[
        {
            "id":"swiper-bundle",
            "path":"https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js"
        }
       
    ]
}

export default function Preview(props) { 
    const [data, setData] = useState({
        html:"",
        data:[]
    });
    const [headerData, setHeaderData] = useState(props.data);
    useEffect(() => {
         app.fetchPost({
          "method":"get",
          "id":props.subcategory
        }).then(function(response){
            if(response.success) {
                if(response.data.data) {
                    setData({
                        html:response.data.html,
                        data:JSON.parse(response.data.data)
                    })
                }
            }
        });
    }, [])

    let header = ''
    if(headerData){
        header = <WidgetHeader data={headerData} mode={"preview"} device={props.device} cartValue={"0"} notificationValue={"0"} locationValue={true}/>
    }
    if(data) {
        return <div className='w-100' style={{height:"100%", "overflowY": "auto"}}>
            <link type="text/css" rel="stylesheet" href={settings.setFonts(data.data)} />
            <link type="text/css" rel="stylesheet" href={"/css/headerLibrary.css"} />
            <link type="text/css" rel="stylesheet" href={"/css/pages.css"} />
            <style>
                {`
                .no-block-add {
                display:none
                }
                `}
            </style>
            <div className='w-100' dangerouslySetInnerHTML={{__html:data.html}} />
        </div>
    }
    return <div className='w-100'></div>
}